import AuthChecker from './AuthChecker.vue'

const authComponents = [AuthChecker]

export default authComponents
